import type { AxiosError } from "axios";
import axios from "axios";

const api = axios.create();

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const currentLanguage = localStorage.getItem("portal-externo-language") || "pt-BR";
    config.headers["Accept-Language"] = currentLanguage;

    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
        return new Promise(() => {}); // Prevent error from propagating and flashing error page
      }
    }
    return Promise.reject(error);
  }
);

export default api;
